import Image from 'next/image';
import Link from 'next/link';

import ChevronIcon from '@/fo/icons/base/icons/chevron24.svg';

import { RubricItem } from '../../types';

import { styles } from './ArticleButton.styles';

export interface ArticleButtonProps {
  data: RubricItem;
  className?: string;
}

export function ArticleButton({ data, className }: ArticleButtonProps) {
  const slots = styles();

  return (
    <Link
      className={slots.base({ className })}
      href={data.url}
    >
      <div className={slots.imageWrapper()}>
        <Image
          src={data.imageUrl}
          alt={data.title}
          fill
          className="object-cover"
        />
      </div>
      <div className={slots.title()}>{data.title}</div>
      <ChevronIcon className={slots.icon()} />
    </Link>
  );
}
